import React from "react";
import {Dialog, Slide, SlideProps} from "@mui/material";
import Icon from '@/view/common/component/Icon'
import BoardView from "@/view/board/BoardView";
import MemberView from "@/view/member/MemberView"
import PlaceView from "@/view/place/PlaceView"
import RankView from "@/view/rank/RankView"

type MenuItemParam = {
    title: string,
    link?: string,
    iconClass?: string,
    className?: string,
    onReturn?: () => void
}

const Transition = React.forwardRef(function Transition(
    props: SlideProps & { children?: React.ReactElement },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="left" ref={ref} {...props} />;
});

const MenuItem = (props:MenuItemParam) => {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    return (
        <>
            <div className={`mrml-24px ptpb-22px flex justify-between ${props.className ? props.className : ''}`} onClick={handleClickOpen}>
                <span>{props.title}</span>
                {props.iconClass &&
                        <Icon iconClass={props.iconClass}/>
                }
            </div>
            <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
                {props.link === 'board' && <BoardView onClose={handleClose}/>}
                {props.link === 'member' && <MemberView onClose={handleClose}/>}
                {props.link === 'place' && <PlaceView onClose={handleClose}/>}
                {props.link === 'rank' && <RankView onClose={handleClose}/>}
            </Dialog>
        </>
    )
}

export default MenuItem